import { gql } from '@apollo/client';

import { ListMetadata } from './types';

export const USE_LIST_HOOK_QUERY = gql`
  query ListQuery($id: Long!) {
    list(id: $id) {
      id
      name
    }
  }
`;

export const USE_LISTS_HOOK_QUERY = gql`
  query ListsQuery($search: String!, $pagination: Pagination!, $sort: Sort!, $filterInfo: ListFilterInfoInput) {
    lists(search: $search, pagination: $pagination, sort: $sort, filterInfo: $filterInfo) {
      info {
        count
      }
      results {
        id
        name
        listType
      }
    }
  }
`;

export const LIST_METADATA_FRAGMENT = gql`
  fragment ListMetadata on List {
    id
    name
  }
`;

export const DEFAULT_LISTS: ListMetadata[] = [];
